import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialState = {
  sidebar: {
    menus: []
  },
  container: {
    //工作区容器的配置
  }
};

export const appSlice = createSlice({
  //app切片，用于初始化一个应用
  name: "app",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setSideBar: (state, action) => {
      state.sidebar = action.payload;
    }
  }
});

export const {setSideBar} = appSlice.actions;

export default appSlice.reducer;
